import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "reports/overall-lead-report",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const overallLeadReport = require("./OverallLeadReport").default;
          cb(null, overallLeadReport);
        },
        "LeadReport"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/LeadReport/OverallLeadReport/index.js